import { takeEvery, put, call, all, fork } from "@redux-saga/core/effects";
import { FETCH_ROLES, SET_ROLES } from "redux/constants/portal";
import { fetchRoles } from "api/RolesApi";

/***** WORKERS *****/

function* handleFetchRoles({ payload }) {
   try {
      const { tenant_id } = payload;
      const roles = yield call(fetchRoles, tenant_id);
      if (roles) {
         yield put({ type: SET_ROLES, payload: roles });
      }
   } catch (error) {
      console.error(error);
   }
}

/***** WATCHERS *****/

function* watchFetchRoles() {
   yield takeEvery(FETCH_ROLES, handleFetchRoles);
}

export function* rootRolesSaga() {
   yield all([fork(watchFetchRoles)]);
}
